module.exports = __webpack_public_path__ + "img/profitable-img-7.7d7a9023.png";